import React, {Component} from "react"
import {connect} from 'react-redux';

import moment from 'moment';

import Layout from "../../../components/Layout"
import TabsNav from "../../../components/TabsNav"
import leng from "../../../data"

import {
    Tab,
    FileUploaderDropContainer,
    Button,
    Tabs,
    DataTable,
    TableContainer,
    TableToolbar,
    TableToolbarContent,
    TableToolbarSearch,
    TableSelectAll,
    TableSelectRow,
    TableHead,
    TableRow,
    TableHeader,
    TableBody,
    Table,
    TableCell,
    Pagination,
    DataTableSkeleton,
} from "carbon-components-react"
import {Download20} from "@carbon/icons-react"
import "./index.scss"

import {
    files_action_count,
    files_action_fetch,
    files_action_download
} from '../../../store/actions/files';


const headers = [
    {key: "originalName", header: leng.repositorio.formato_table_header.table[0]},
    {key: "user", header: leng.repositorio.formato_table_header.table[1]},
    {key: "timestamp", header: leng.repositorio.formato_table_header.table[2]},
    {key: "download", header: leng.repositorio.formato_table_header.table[3]},
];

/*
    FILE
    USER
    Upload Date
    Download FIle
 */

class Formato extends Component {

    state = {
        checkedItems: [],
        itemsToDelete: [],
        showAlert: false,
        filterValue: {},
        start: 0,
        pageSize: 20,
        page: 1,
    };

    componentDidMount() {
        this.props.countFiles();
        this.props.fetchData({
            pageSize: 20,
            page: 1
        });
    }

    async onChangePagination(arg1, arg2, arg3) {
        await this.setState(prevState => ({
            start: this.state.start == 0 ? (arg1.page * arg1.pageSize) - 20 : this.state.start * arg1.page,
            pageSize: arg1.pageSize,
            page: arg1.page,
        }))
        await this.props.fetchData({
            start: this.state.start == 0 ? (arg1.page * arg1.pageSize) - 20 : this.state.start * arg1.page,
            pageSize: arg1.pageSize,
            page: arg1.page,
        })
    }

    handleDownload = (originalFile, originalName, bucket) => e => {
        e.preventDefault();
        //alert(originalName);
        var name = originalName.split('/');
        var nameOriginal = name[name.length - 1];

        //alert(nameOriginal);
        this.props.downloadFiles(originalFile, nameOriginal, bucket);
    };

    render() {
        let {data, countRepository, isLoading} = this.props;
        let rows = data;
        rows =
            data?.length > 0
                ? data.map(execution => {
                    return {
                        ...execution,
                        id: execution._id,
                        timestamp: moment(execution.statusChangeDate).format('D MMM YYYY H:mm'),
                        sortDate: new Date(execution.statusChangeDate),
                        download: (
                            <div className="text-center">
                                <a title="Fazer Download" href="#download"
                                   onClick={this.handleDownload(execution.originalFile, execution.originalName, execution.bucket)}>
                                    <Download20 size="small"/>
                                </a>
                            </div>
                        )
                    };
                })
                : [];
        if (rows?.length > 0) rows.sort((a, b) => b.sortDate - a.sortDate);

        return (
            <Layout>
                <div className="section">
                    <div className="section-heading">
                        <br/>
                        <p>{leng.sideBar.repositorio.title}</p>
                        <h1>{leng.sideBar.repositorio.links[0]}</h1>
                        <br/>
                    </div>

                </div>

                <div className="section-light">
                    <div className="section-light-heading">
                        <div className="file-upload-container">
                            <div>
                                {isLoading ? (
                                    <DataTableSkeleton/>
                                ) : (
                                    <DataTable rows={rows} headers={headers}>
                                        {({
                                              rows,
                                              headers,
                                              getHeaderProps,
                                              getRowProps,
                                              getTableProps,
                                              getSelectionProps,
                                              onInputChange,
                                          }) => (
                                            <TableContainer title={leng.repositorio.formato.table_title}
                                                            description={countRepository + " arquivos"}
                                                            className="upload-table">
                                                <TableToolbar>
                                                    <TableToolbarContent>
                                                    </TableToolbarContent>
                                                </TableToolbar>
                                                <Table {...getTableProps()}>
                                                    <TableHead>
                                                        <TableRow>
                                                            {headers.map((header) => (
                                                                <TableHeader
                                                                    key={header.key}
                                                                    {...getHeaderProps({header})}
                                                                    >
                                                                    {header.header == leng.repositorio.formato_table_header.table[3] ?
                                                                        <div
                                                                            className="text-center">{header.header}</div> :
                                                                        header.header
                                                                    }

                                                                </TableHeader>
                                                            ))}
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {rows.map((row) => (
                                                            <TableRow
                                                                className="upload-row"
                                                                key={row.id}
                                                                {...getRowProps({row})}
                                                            >
                                                                {row.cells.map((cell) => (
                                                                    <TableCell key={cell.id}>
                                                                        {cell.value}
                                                                    </TableCell>
                                                                ))}
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                                <Pagination
                                                    className="paginator"
                                                    totalItems={countRepository}
                                                    pageSizes={[20, 40]}
                                                    backwardText="Previous"
                                                    forwardText="Next"
                                                    pageSize={this.state.pageSize}
                                                    itemsPerPageText={"Items per page"}
                                                    page={this.state.page}
                                                    onChange={(arg1, arg2, arg3) => {
                                                        this.onChangePagination(arg1, arg2, arg3);
                                                    }}
                                                >

                                                </Pagination>
                                            </TableContainer>
                                        )}
                                    </DataTable>
                                )}
                            </div>

                        </div>
                    </div>
                </div>

            </Layout>
        )

    }
}


const
    mapStateToProps = ({files}) => files;

const
    mapDispatchToProps = dispatch => ({
        countFiles: () => dispatch(files_action_count()),
        fetchData: params => dispatch(files_action_fetch(params)),
        downloadFiles: (originalName, originalFile, bucket) => dispatch(files_action_download(originalName, originalFile, bucket))
    });

export default connect(
    mapStateToProps,
    mapDispatchToProps
)

(
    Formato
)
;
